<template>
  <div>
    <b-card
      no-body
      class="mb-2"
    >
      <b-card-body class="d-flex justify-content-between align-items-center">
        <div>
          <h4 class="mb-0">
            Kullanım İstatistikleri
          </h4>
          <small class="text-muted">Lisans #{{ licenseId }} için DR verileri</small>
        </div>
        <b-button
          size="sm"
          variant="outline-primary"
          :disabled="loading || !licenseId"
          @click="loadStatistics"
        >
          <feather-icon
            icon="RefreshCwIcon"
            size="14"
            class="mr-50"
          />
          Yenile
        </b-button>
      </b-card-body>
    </b-card>

    <b-alert
      v-if="error"
      show
      variant="danger"
    >
      <div class="alert-body">
        {{ error }}
      </div>
    </b-alert>

    <b-row>
      <b-col
        cols="12"
        md="6"
        lg="4"
      >
        <b-card title="Disk Kullanımı">
          <div class="d-flex mb-1 font-weight-bold">
            <div>{{ formatNumber(stats.diskUsage.usage) }} MB</div>
            <div class="mx-1">/</div>
            <div>{{ formatNumber(stats.diskUsage.limit) }} MB</div>
          </div>
          <b-progress
            :value="stats.diskUsage.usage"
            :max="diskProgressMax"
            variant="warning"
            class="mb-1 bg-light-warning"
            height="1.25rem"
          />
          <small class="text-muted">%{{ formatNumber(stats.diskUsage.percent) }} kullanıldı</small>
        </b-card>
      </b-col>

      <b-col
        cols="12"
        md="6"
        lg="4"
      >
        <stat-metric-card
          title="Kullanıcı Sayısı"
          :usage="stats.userCount.usage"
          :limit="stats.userCount.limit"
          icon="UsersIcon"
          color="primary"
        />
      </b-col>

      <b-col
        cols="12"
        md="6"
        lg="4"
      >
        <stat-metric-card
          title="Ürün Adet"
          :usage="stats.productCount.usage"
          :limit="stats.productCount.limit"
          icon="CoffeeIcon"
          color="success"
        />
      </b-col>

      <b-col
        cols="12"
        md="6"
        lg="4"
      >
        <stat-metric-card
          title="Aylık Ziyaret Ortalaması"
          :usage="stats.monthlyVisitAvg"
          :limit="0"
          icon="EyeIcon"
          color="info"
          hide-limit
        />
      </b-col>

      <b-col
        cols="12"
        md="6"
        lg="4"
      >
        <stat-metric-card
          title="Ürün Kategorisi"
          :usage="stats.categoryCount.usage"
          :limit="stats.categoryCount.limit"
          icon="FolderIcon"
          color="warning"
        />
      </b-col>

      <b-col
        cols="12"
        md="6"
        lg="4"
      >
        <stat-metric-card
          title="QR Kod Sayısı"
          :usage="stats.qrCount.usage"
          :limit="stats.qrCount.limit"
          icon="LinkIcon"
          color="secondary"
        />
      </b-col>
    </b-row>

    <div
      v-if="loading"
      class="text-center text-muted py-1"
    >
      İstatistikler yükleniyor...
    </div>
  </div>
</template>

<script>
import {
  BAlert,
  BButton,
  BCard,
  BCardBody,
  BCol,
  BProgress,
  BRow,
} from 'bootstrap-vue'
import StatMetricCard from '@/views/Admin/Licenses/UsageStatistics/StatMetricCard.vue'

export default {
  name: 'DrStatistics',
  components: {
    BAlert,
    BButton,
    BCard,
    BCardBody,
    BCol,
    BProgress,
    BRow,
    StatMetricCard,
  },
  computed: {
    licenseId() {
      const item = this.$store.getters['licenses/dataItem']
      return (item && item.id) || this.$route.params.id || null
    },
    loading() {
      return this.$store.getters['drStatistics/loading']
    },
    stats() {
      return this.$store.getters['drStatistics/dataItem']
    },
    error() {
      return this.$store.getters['drStatistics/error']
    },
    diskProgressMax() {
      const limit = Number(this.stats.diskUsage.limit) || 0
      const usage = Number(this.stats.diskUsage.usage) || 0
      return Math.max(limit, usage, 1)
    },
  },
  watch: {
    licenseId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadStatistics()
        }
      },
    },
  },
  beforeDestroy() {
    this.$store.commit('drStatistics/RESET_DATA_ITEM')
  },
  methods: {
    loadStatistics() {
      if (!this.licenseId) return
      this.$store.dispatch('drStatistics/getStatistics', this.licenseId)
    },
    formatNumber(value) {
      const num = Number(value)
      if (Number.isNaN(num)) return '0'
      return new Intl.NumberFormat('tr-TR', {
        maximumFractionDigits: 2,
      }).format(num)
    },
  },
}
</script>
